import React from 'react';
import { Container } from '@mui/material';

/**
 * Layout for pages to show header, footer, and body content.
 * @param {object} props Props accepted  by the component.
 * @param {object} props.children Component to use as body.
 * @param {object} props.header Header component to use.
 * @param {object} props.footer Footer component to use.
 * @returns {import('react').FunctionComponent} React element that contains the layout.
 */
function PageLayout({ children, header, footer }) {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      {header}
      <Container
        role="main"
        maxWidth="sm"
        disableGutters
        sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}
      >
        {children}
      </Container>
      {footer}
    </Container>
  );
}

export default PageLayout;
